/**
 * The strategy help control's own words.
 *
 * Read from `useLanguage()` inside the control, the rule `supportCopy` follows:
 * the invitation belongs to the control rather than to the editor it stands
 * in. Defaulted field by field against `en`, because a partial `t` is what the
 * editor's test harnesses hand the components rendered in it, and a missing
 * sentence must not take the editor down with it.
 */

import { en } from "../../i18n/en";

type StrategyHelpKey = keyof typeof en.strategyHelp;

export type StrategyHelpCopy = Record<StrategyHelpKey, string>;

export function strategyHelpCopy(
    t: { strategyHelp?: Partial<Record<StrategyHelpKey, string>> },
): StrategyHelpCopy {
    const group = t.strategyHelp ?? {};
    return Object.fromEntries(
        (Object.keys(en.strategyHelp) as StrategyHelpKey[]).map((key) => [key, group[key] ?? en.strategyHelp[key]]),
    ) as StrategyHelpCopy;
}
